module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.rerender) ? _c('div', {
    staticClass: "map-container",
    attrs: {
      "id": _vm.mapId
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panelMode === 'location-pin'),
      expression: "panelMode === 'location-pin'"
    }],
    class: {
      'map-pin': true, drag: _vm.dragging
    }
  }, [_c('i', {
    staticClass: "fa fa-map-pin fa-2x brand-text"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCover),
      expression: "showCover"
    }],
    staticClass: "booking-map-cover"
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lds-ripple"
  }, [_c('div'), _c('div')])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-04951985", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04951985","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchForm/BookingMap.vue
// module id = 2028
// module chunks = 0